import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var subjective = {
  pmh: {
    type: 'input',
    title: 'PMH'
  },
  mc: {
    type: 'tag',
    title: 'MC(Female Only)',
    value: [],
    suggestions: [{
      id: 'irregular',
      text: 'irregular'
    }, {
      id: 'PMS',
      text: 'PMS'
    }, {
      id: 'menopausal',
      text: 'menopausal'
    }]
  },
  drug_in_use: {
    type: 'input',
    title: 'Drug in use'
  },
  fmh: {
    type: 'tag',
    title: 'FMH',
    value: [],
    suggestions: [{
      id: 'Mother had',
      text: 'Mother had'
    }, {
      id: 'Father had',
      text: 'Father had'
    }]
  }
};
var objective = {
  Abdominal_Sono_Fattyliver: {
    type: 'tag',
    title: 'Abdominal Sono: Fattyliver',
    value: [],
    suggestions: [{
      id: 'Neg',
      text: 'Neg'
    }, {
      id: 'Mild',
      text: 'Mild'
    }, {
      id: 'Moderate',
      text: 'Moderate'
    }, {
      id: 'Severe',
      text: 'Severe'
    }]
  },
  an: {
    type: 'tag',
    title: 'AN:',
    value: [],
    suggestions: [{
      id: '+',
      text: '+'
    }, {
      id: '++',
      text: '++'
    }, {
      id: '+++',
      text: '+++'
    }]
  },
  striae: {
    type: 'tag',
    title: 'Striae',
    value: [],
    suggestions: [{
      id: 'Yes',
      text: 'Yes'
    }, {
      id: 'No',
      text: 'No'
    }]
  },
  heart: {
    type: 'input',
    title: 'Heart'
  },
  objective_other: {
    type: 'input',
    title: 'Other'
  }
};
var assessment = {
  assessment_abdominal_sono: {
    type: 'tag',
    title: '',
    value: [],
    suggestions: [{
      id: 'Obesity',
      text: 'Obesity'
    }, {
      id: 'IRS',
      text: 'IRS'
    }, {
      id: 'DM ',
      text: 'DM '
    }]
  }
};

var plan = function plan(t) {
  return {
    nutritional_conseling: {
      title: '1. Nutritional Consuling',
      type: 'input',
      value: ''
    },
    diet: {
      title: '2. Diet(NAFPK)',
      type: 'input',
      value: ''
    },
    other_comments: {
      title: 'Other Comments',
      type: 'input',
      value: '',
      indent: 4
    },
    currentWeight: {
      key: 'currentWeight',
      title: (t === null || t === void 0 ? void 0 : t('common:soap.thisClinicWeight', '3. 本次門診體重：')) || '3. 本次門診體重：',
      type: 'currentWeight'
    },
    targetPercent: {
      key: 'targetPercent',
      title: (t === null || t === void 0 ? void 0 : t('common:soap.everyPhaseTargetRate', '每期目標 %')) || '每期目標 %',
      type: 'targetPercent',
      value: 8
    },
    targetWeight: {
      key: 'targetWeight',
      title: (t === null || t === void 0 ? void 0 : t('common:soap.targetWeight', '目標體重')) || '目標體重',
      type: 'targetWeight'
    },
    currentHeight: {
      key: 'currentHeight',
      title: (t === null || t === void 0 ? void 0 : t('common:soap.targetHeight', '當前身高')) || '當前身高',
      type: 'currentHeight'
    },
    weight_target: {
      title: 'Moderate Weight',
      type: 'weight_moderate',
      value: []
    },
    fasting_detail: {
      title: 'Fasting Frequecy Suggesting',
      type: 'fasting_derail'
    },
    exercise_prescription: {
      type: 'tag',
      title: (t === null || t === void 0 ? void 0 : t('common:soap.exercisePrescription4', '4. 運動處方:')) || '4. 運動處方:',
      value: [],
      suggestions: [{
        id: '爬梯',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.ladder', '爬梯')) || '爬梯'
      }, {
        id: '深蹲',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.squat', '深蹲')) || '深蹲'
      }, {
        id: '伏地挺身',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.pushUp', '伏地挺身')) || '伏地挺身'
      }, {
        id: '核心',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.core', '核心')) || '核心'
      }, {
        id: '有氧',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.aerobic', '有氧')) || '有氧'
      }, {
        id: '多走路，提升活動量，避免久坐',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.exerciseComplex', '多走路，提升活動量，避免久坐')) || '多走路，提升活動量，避免久坐'
      }]
    },
    plan_suggest: {
      title: '5. 控糖減脂門診方案建議',
      type: 'tag',
      value: [],
      suggestions: [{
        id: '減重療程(VIP)',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.weightLossVIP', '減重療程(VIP)')) || '減重療程(VIP)'
      }, {
        id: '減重療程(藥品)',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.drugTreatment', '減重療程(藥品)')) || '減重療程(藥品)'
      }, {
        id: '減重療程(針劑點滴)',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.drugInjectionTreatment', '減重療程(針劑點滴)')) || '減重療程(針劑點滴)'
      }, {
        id: '減重療程(保健品)',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.healthProductsTreatment', '減重療程(保健品)')) || '減重療程(保健品)'
      }, {
        id: '門診餐飲指導',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.cateringGuidance', '門診餐飲指導')) || '門診餐飲指導'
      }, {
        id: '抽血檢查',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.bloodTest', '抽血檢查')) || '抽血檢查'
      }, {
        id: 'N餐盤',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.diet', 'N餐盤', {
          name: 'N'
        })) || 'N餐盤'
      }, {
        id: 'A餐盤',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.diet', 'A餐盤', {
          name: 'A'
        })) || 'A餐盤'
      }, {
        id: 'F餐盤',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.diet', 'F餐盤', {
          name: 'F'
        })) || 'F餐盤'
      }, {
        id: 'P餐盤',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.diet', 'P餐盤', {
          name: 'P'
        })) || 'P餐盤'
      }, {
        id: 'K餐盤',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.diet', 'K餐盤', {
          name: 'K'
        })) || 'K餐盤'
      }, {
        id: '營養師線上指導',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.nutritionistOnlineGuidance', '營養師線上指導')) || '營養師線上指導'
      }, {
        id: 'ILIB',
        text: 'ILIB'
      }, {
        id: 'Cofit App 使用及登錄',
        text: (t === null || t === void 0 ? void 0 : t('common:soap.appUsageAndLogin', 'Cofit App 使用及登錄')) || 'Cofit App 使用及登錄'
      }]
    },
    plan_other: {
      type: 'input',
      title: '6. Other'
    }
  };
};

export var getSOAP = function getSOAP(t) {
  return {
    plan: {
      title: 'PLAN TO DO',
      value: plan(t)
    },
    // the following are old comment fotmat
    dr_comment: '',
    pre_rd_comment: '',
    post_rd_comment: '',
    pharmacist_comment: '',
    nurse_comment: ''
  };
};
export var soapWithNewCommentFormat = function soapWithNewCommentFormat(t) {
  return {
    plan: {
      title: 'PLAN TO DO',
      value: plan(t)
    }
  };
}; //only show SOA on diagnosis history page

export var soapWithSOA = function soapWithSOA(t) {
  return _objectSpread({
    subjective: {
      title: 'SUBJETIVE',
      value: subjective
    },
    objective: {
      title: 'OBJECTIVE',
      value: objective
    },
    assessment: {
      title: 'ASSESSMENT/DIAGNOSIS',
      value: assessment
    }
  }, getSOAP(t));
};